import { Injectable, OnDestroy } from '@angular/core';
import * as Atmosphere from 'atmosphere.js';
import { Base64 } from 'js-base64';
import { Subject } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { AbmConfigService } from './abm-config.service';
import { AbmLoggerService } from './abm-logger.service';

export class AbmWsMessage {
  public uuid: string;
  public extra: string;
  constructor(
    public sender: string,
    public message: string,
  ) { }
}

@Injectable({
  providedIn: 'root'
})
export class AbmWsService implements OnDestroy {

  private enable: boolean;
  private socket = Atmosphere;
  private request = new Atmosphere.AtmosphereRequest();
  private subSocket: any;

  public dataStream: Subject<AbmWsMessage> = new Subject();

  private _uuid: string;

  constructor(
    private _config: AbmConfigService,
    private _logger: AbmLoggerService
  ) {

    this.enable = this._config.config.be.wsEnable;

    if (!this.enable) {
      return;
    }

    this._uuid = uuid();

    this.request = {
      url: this._config.config.be.url + this._config.config.be.ws,
      contentType: 'application/json',
      logLevel: 'debug',
      transport: 'websocket',
      trackMessageLength: true,
      fallbackTransport: 'long-polling',
      reconnectInterval: 10000,
      heartbeat: { server: 60, client: 60 },
      uuid: this._uuid,
      timeout: -1,
      onOpen: (response) => {
        this._logger.info('Atmosphere connected using ' + response.transport);
      },
      onMessage: (response) => {
        const msg: AbmWsMessage = JSON.parse(Base64.decode(response.responseBody));

        if (msg.uuid !== this._uuid) {
          this._logger.debug('Atmosphere get message ' + msg.message);
          this.dataStream.next(msg);
        }
      },
      onReconnect: (request, response) => {
        this._logger.warn('reconnect', request, response);
      },
      onClientTimeout: response => {
        this._logger.warn('client timeout', response);
        this.disconnect();
        this.connect();
      },
      onClose: (response) => {
        this._logger.warn('connection closed');
      },
      onError: (response) => {
        this._logger.error('error', response);
        this.dataStream.error(response);
      }
    };
  }

  ngOnDestroy(): void {
    this.disconnect();
    this.dataStream.complete();
  }

  public connect() {
    if (!this.subSocket) {
      this._logger.info('start connect atmosphere at:' + this._config.config.be.url + this._config.config.be.ws);
      this.subSocket = this.socket.subscribe(this.request);
    }
  }

  public disconnect() {
    if (this.subSocket) {
      this._logger.info('Disconnecting websocket...');
      this.socket.unsubscribe();
      this.subSocket = null;
    }
  }

  public send(data: AbmWsMessage | { sender: string, content: any }) {

    if (!this.enable || !this.subSocket) {
      return;
    }

    let msg: AbmWsMessage;

    if (data instanceof AbmWsMessage) {
      msg = data;
    } else {
      msg = new AbmWsMessage(data.sender, JSON.stringify(data.content));
    }

    msg.uuid = this._uuid;

    const msgStr = JSON.stringify(msg);
    this._logger.debug('Atmosphere sending:' + msgStr);
    this.subSocket.push(Base64.encode(msgStr));
  }
}
